<template>
    <div>
        <AddEditDocument :isNew="true" :isContract="isContract" :isEngineer="isEngineer" />
        <v-data-table
            class="mt-5"
            :headers="headers"
            :items="DLT"
            :options.sync="pagination"
            :server-items-length="ListLength"
            :footer-props="{ 'items-per-page-options': $vuetify.breakpoint.xsOnly ? [1] : [10, 15, 20, 25] }"
        >
            <template v-slot:item.dt_add="{ item }">
                <span> {{ item.dt_add | formatDate }} </span>
            </template>
            <template v-slot:item.is_sign="{ item }">
                <div class="d-flex align-center">
                    <div>
                        <span> {{ item.is_sign ? $t('да') : $t('нет') }} </span>
                    </div>
                </div>
            </template>
            <template v-slot:item.action="{ item }">
                <div class="d-flex align-center">
                    <div>
                        <AddEditDocument :isNew="false" :documentItem="item" :isContract="isContract" :isEngineer="isEngineer" />
                    </div>
                    <div>
                        <DeleteDocumentDialog :isNew="false" :documentItem="item" :isContract="isContract" v-if="item.can_delete" hidden />
                    </div>
                </div>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import translate from '@/utils/translate.util';
import { mapState, mapActions } from 'vuex';
import AddEditDocument from '@/components/ui/AddEditDocument.vue';
import DeleteDocumentDialog from '@/components/ui/DeleteDocumentDialog.vue';

export default {
    name: 'DocumentsC',
    components: { AddEditDocument, DeleteDocumentDialog },
    data: () => ({
        isContract: false,
        isEngineer: false,
        ContractRid: null,
        KSKRid: null
    }),
    computed: {
        ...mapState('documents', ['DocumentList', 'Pagination', 'ListLength']),
        ...mapState('users', ['userInfo']),
        headers: function() {
            return [
                {
                    text: this.$t('Дата создания документа'),
                    sortable: false,
                    value: 'dt_add'
                },
                {
                    text: this.$t('Наименование документа'),
                    sortable: false,
                    value: 'doc_type_name'
                },
                {
                    text: this.$t('Наименование объекта / адреса дома'),
                    sortable: false,
                    value: 'info_name'
                },
                {
                    text: this.$t('Кем создан документ'),
                    sortable: false,
                    value: 'user_name'
                },
                {
                    text: this.$t('Документ подписан'),
                    sortable: false,
                    value: 'is_sign'
                },
                {
                    text: this.$t(''),
                    sortable: false,
                    value: 'action'
                }
            ];
        },
        DLT() {
            return translate(this.DocumentList, 'full', this.$i18n.locale);
        },
        pagination: {
            get() {
                return this.Pagination;
            },
            async set(val) {
                if (this.isContract) {
                    await this.getDocumentList({
                        ContractRid: this.ContractRid,
                        itemsPerPage: val.itemsPerPage,
                        currentItem: val.itemsPerPage * (val.page - 1)
                    });
                } else {
                    await this.getDocumentList({
                        KSKRid: this.KSKRid,
                        itemsPerPage: val.itemsPerPage,
                        currentItem: val.itemsPerPage * (val.page - 1)
                    });
                }
                this.$store.commit('documents/setPagination', val);
            }
        }
    },
    methods: {
        ...mapActions('documents', ['getDocumentList', 'getRefAhsDocTypes', 'getUserContractsList', 'getUserObjectContractsList', 'getKSKHousesList']),
        ...mapActions('users', ['getUserInfo'])
    },
    async created() {
        // this.ContractRid = 10855;
        // this.KSKRid = 1;

        await this.getUserInfo();
        if (this.userInfo && this.userInfo.user_data && this.userInfo.user_data.isas_engineer_rid) {
            this.isEngineer = true;
        } else if (this.userInfo && this.userInfo.user_data && this.userInfo.user_data.isas_ksk_rid) {
            this.KSKRid = this.userInfo.user_data.isas_ksk_rid;
            this.isContract = false;
        } else if (this.userInfo && this.userInfo.user_data && this.userInfo.user_data.isas_contract_rid) {
            this.ContractRid = this.userInfo.user_data.isas_contract_rid;
            this.isContract = true;
        }

        if (this.isEngineer) {
            await this.getDocumentList({ ContractRid: this.ContractRid, itemsPerPage: 10, currentItem: 0 });
            await this.getUserContractsList({ ContractRid: this.ContractRid });
            await this.getKSKHousesList({ KSKRid: this.KSKRid });
        } else if (this.isContract) {
            await this.getDocumentList({ ContractRid: this.ContractRid, itemsPerPage: 10, currentItem: 0 });
            await this.getUserContractsList({ ContractRid: this.ContractRid });
        } else {
            await this.getDocumentList({ KSKRid: this.KSKRid, itemsPerPage: 10, currentItem: 0 });
            await this.getKSKHousesList({ KSKRid: this.KSKRid });
        }
    }
};
</script>
